// src/components/Form/Form.tsx

import React from 'react';
import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form';

interface FormProps<TFormValues extends FieldValues> {
  onSubmit: (values: TFormValues) => void | Promise<void>;
  methods: UseFormReturn<TFormValues>;
  children: React.ReactNode;
  noValidate?: boolean;
  className?: string;
}

export const Form = <TFormValues extends FieldValues>({
  onSubmit,
  methods,
  children,
  noValidate = false,
  className,
}: FormProps<TFormValues>) => {
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        noValidate={noValidate}
        className={className}
      >
        {children}
      </form>
    </FormProvider>
  );
};
